import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "down-arrow",
  "use": "down-arrow-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol viewBox=\"0 0 14 8\" id=\"down-arrow\">\n    <g fill=\"#9B9B9B\" fill-rule=\"evenodd\" transform=\"translate(-1 -1)\">\n        <rect width=\"10\" height=\"2\" y=\"4\" rx=\"1\" transform=\"rotate(45 5 5)\" />\n        <rect width=\"10\" height=\"2\" x=\"6\" y=\"4\" rx=\"1\" transform=\"scale(-1 1) rotate(45 0 -21.556)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svgs/down-arrow.svg
// module id = 166
// module chunks = 0